var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.hideSmallCalendar,
          expression: "hideSmallCalendar",
        },
      ],
      staticClass: "bb-period-filter",
    },
    [
      _c("div", { staticClass: "bb-period-filter-buttons" }, [
        _c(
          "button",
          {
            staticClass: "bb-period-filter-prev-btn",
            class: _vm.shadowClass,
            on: {
              click: function ($event) {
                return _vm.switchPeriod("prev")
              },
            },
          },
          [_c("i", { staticClass: "la la-angle-left" })]
        ),
        _c(
          "div",
          {
            staticClass: "bb-period-filter-title",
            class: _vm.shadowClass,
            on: { click: _vm.toggleSmallCalendar },
          },
          [_c("span", [_vm._v(_vm._s(_vm.periodTitle))])]
        ),
        _c(
          "button",
          {
            staticClass: "bb-period-filter-next-btn",
            class: _vm.shadowClass,
            on: {
              click: function ($event) {
                return _vm.switchPeriod("next")
              },
            },
          },
          [_c("i", { staticClass: "la la-angle-right" })]
        ),
      ]),
      _c("b-calendar", {
        ref: "smallCalendar",
        attrs: {
          "hide-header": true,
          "today-variant": "success",
          locale: _vm.locale,
          hidden: _vm.smallCalendarHidden,
          "date-info-fn": _vm.dateClass,
          "start-weekday": 1,
        },
        on: { context: _vm.onContext, selected: _vm.onDateSelect },
        scopedSlots: _vm._u([
          {
            key: "nav-prev-month",
            fn: function () {
              return [
                _c("i", {
                  staticClass: "la la-arrow-left b-calendar-custom-nav",
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "nav-next-month",
            fn: function () {
              return [
                _c("i", {
                  staticClass: "la la-arrow-right b-calendar-custom-nav",
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "nav-this-month",
            fn: function () {
              return [
                _c(
                  "span",
                  {
                    staticClass: "b-calendar-month-string",
                    staticStyle: { "margin-right": "5px" },
                  },
                  [_vm._v(_vm._s(_vm.monthString))]
                ),
                _c("span", { staticClass: "b-calendar-year-string" }, [
                  _vm._v(_vm._s(_vm.yearString)),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.selectedPeriodDate,
          callback: function ($$v) {
            _vm.selectedPeriodDate = $$v
          },
          expression: "selectedPeriodDate",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }